import React from "react";
import { IconExternalLink } from "@tabler/icons-react";

export function makeAdminDetailsMenuItem(url) {
	return {
		text: "Admin Details",
		color: "var(--lxw-hyperlink)",
		onSelect: () => window.open(url, "_blank"),
		iconComponent: (
			<IconExternalLink
				color={"var(--lxw-hyperlink)"}
				size={16}
				style={{ verticalAlign: "sub" }}
			/>
		),
	};
}
